import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { loadMetrika } from './metrika';

loadMetrika(environment.metrikaId);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
